/**
 * Supported ION networks.
 */
enum IonNetwork {
  Mainnet = 'mainnet',
  Testnet = 'test'
}

export default IonNetwork;
